import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const SrInfoCard = ({ number, title, description, imageUrl }) => {
  return (
    <SrBox
      width="100%"
      height="508px"
      backgroundColor="#F4EDE3"
      borderRadius="8px"
      padding="48px 24px 0"
      boxSizing="border-box"
      marginBottom="164px"
    >
      <SrBox
        backgroundColor="#04121F"
        borderRadius="12px"
        width="100px"
        height="100px"
        margin="0 auto 24px"
        paddingTop="16px"
        boxSizing="border-box"
      >
        <SrText
          color="white"
          font="greycliff"
          weight="800"
          fontSize="56px"
          lineHeight="67px"
          align="center"
          display="block"
        >
          {number}
        </SrText>
      </SrBox>
      <SrBox padding="0 16px">
        <SrText
          color="fontBlueDark"
          font="greycliff"
          weight="800"
          size="24"
          lineHeight="32px"
          align="center"
          display="block"
          letterSpacing="0px"
        >
          {title}
        </SrText>
      </SrBox>
      <SrBox marginTop="24px">
        <SrText
          color="grey500"
          font="greycliff"
          weight="600"
          size="16"
          lineHeight="24px"
          align="center"
          display="block"
          letterSpacing="0px"
        >
          {description}
        </SrText>
      </SrBox>
      <SrBox
        width="296px"
        maxWidth="calc(100vw - 88px)"
        height="296px"
        borderRadius="12px"
        backgroundImage={`url(${imageUrl})`}
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundRepeat="noRepeat"
        margin="42px auto 0"
        boxShadow="0px 15px 30px 0px rgba(219, 219, 219, 0.25)"
      />
    </SrBox>
  );
};

SrInfoCard.propTypes = {
  number: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

SrInfoCard.displayName = 'SrInfoCard';

export default SrInfoCard;
